import * as React from "react";

interface IProps {
    separator?: React.ReactNode;
    components: React.ReactNode[];
}

export const JoinComponents: React.FC<IProps> = (props) => {
    if (props.components == null)
        return null;

    const c = props.components.filter(p => p != null);
    if (c.length == 0)
        return null;

    return (
        <>
            {
                c.map((v, index) => (
                    <React.Fragment key={index}>
                        {v}
                        {index < c.length - 1 ? <span>&nbsp;{props.separator || <span>&ndash;</span>}&nbsp;</span> : null}
                    </React.Fragment>)
                )
            }
        </>
    );
};
